// ABOUTME: The /shop route: the TE store's shop, loaded on demand, where it shows (teShopAvailable: .ru, beta, dev)
// ABOUTME: Elsewhere it leads to the home page — a .com host is to get a shop of its own

import { lazy, type FC } from "react"
import { Navigate } from "react-router"
import { teShopAvailable } from "@/model/store/teShop"

const Shop = lazy(() => import("./ShopPage"))

export const ShopRoute: FC = () =>
  teShopAvailable() ? (
    <Shop />
  ) : (
    <Navigate
      to="/"
      replace
    />
  )
